import type { ThumbnailStyle } from '@/@types/aiStyle';

export const AI_STYLE_THUMBNAILS: readonly ThumbnailStyle[] = [
  {
    id: '1',
    title: '3D 애니메이션',
    titleEn: '3d_animation',
    image: '/assets/images/ai/3d_animation.png',
    imageStylePrompt:
      'Pixar-style 3D animation, soft and rounded modeling, high-quality texture and material rendering, warm and cheerful lighting, stylized proportions with realistic shading, smooth and appealing character design, CG animation look inspired by modern family-friendly movies'
  },
  {
    id: '2',
    title: '2D 애니메이션',
    titleEn: '2d_animation',
    image: '/assets/images/ai/felt_style.png',
    imageStylePrompt:
      'soft and rounded character designs with simplified shapes, pastel color palette, flat cel-shading, and expressive cartoon faces. consistent thick line art, minimal but warm and colorful backgrounds. calm, whimsical, and heartwarming cartoon style, inspired by Steven Universe.'
  },
  {
    id: '3',
    title: '일본 애니메이션',
    titleEn: 'japan_animation',
    image: '/assets/images/ai/japan_animation.png',
    imageStylePrompt:
      'Makoto Shinkai anime style, highly detailed backgrounds with realistic skies, clouds, and dramatic lighting. vivid and saturated colors with strong contrasts. characters drawn with clean line art, simplified shading, and realistic proportions. cinematic and emotional atmosphere, capturing the dreamy and heartwarming tone of Suzume no Tojimari.'
  },
  {
    id: '4',
    title: '웹툰',
    titleEn: 'webtoon_style',
    image: '/assets/images/ai/webtoon_style.png',
    imageStylePrompt:
      "Korean webtoon fantasy art style inspired by 'Solo Leveling'. high contrast and colorful. glowing effects. characters drawn with semi-realistic proportions, sharp linework, and intense expressions. dramatic and stylish fantasy illustration."
  },
  {
    id: '5',
    title: '현실적인',
    titleEn: 'realistic',
    image: '/assets/images/ai/realistic.png',
    imageStylePrompt:
      'highly realistic 3D illustration style with detailed textures, lifelike skin and fabric rendering, cinematic lighting and shadows. semi-realistic character design blended with polished 3D rendering. atmospheric and immersive mood, similar to high-end game cinematics or concept art. refined materials, depth, and realism in a painterly yet 3D-inspired illustration.'
  },
  {
    id: '6',
    title: '유화',
    titleEn: 'oil_painting_style',
    image: '/assets/images/ai/oil_painting_style.png',
    imageStylePrompt:
      'oil pastel style landscape with crayon-like textures, thick and rough strokes, softly blended colors. hand-drawn tactile aesthetic, warm and expressive analog artwork with the charm of traditional oil pastels.'
  },
  {
    id: '7',
    title: '동양화',
    titleEn: 'oriental_animation',
    image: '/assets/images/ai/oriental_animation.png',
    imageStylePrompt:
      'traditional East Asian painting style illustration, blending ink wash and colored painting techniques. soft brushstrokes with subtle gradients, ink bleed textures, muted and elegant color palette. serene and poetic atmosphere with balanced composition, capturing the harmony of nature and characters in a painterly style.'
  },
  {
    id: '8',
    title: '디지털 드로잉',
    titleEn: 'digital_drawing',
    image: '/assets/images/ai/digital_drawing.png',
    imageStylePrompt:
      'Create a digital artwork in a soft, watercolor-inspired style with visible brushstrokes. The illustration should have a fluid, delicate feel with a subtle, natural blending of colors. The artwork should have a smooth, painterly texture with a soft focus, slightly desaturated hues, and a balanced light and shadow to create a calming, serene atmosphere. The brushwork should be loose and expressive, adding depth and texture while maintaining a gentle, refined appearance.'
  },
  {
    id: '9',
    title: '픽셀',
    titleEn: 'pixel_style',
    image: '/assets/images/ai/pixel_style.png',
    imageStylePrompt:
      '16-bit retro pixel art style inspired by classic RPGs. low-resolution characters and environments, limited color palette, clean sprite outlines, simple yet charming animations. blocky textures, crisp pixels, and nostalgic adventure game aesthetics. stylized like old-school SNES or GBA games with a modern polish.'
  },
  {
    id: '10',
    title: '점토',
    titleEn: 'clay',
    image: '/assets/images/ai/clay.png',
    imageStylePrompt:
      'clay art style with soft and rounded modeling, handmade texture, stop-motion animation aesthetic. tactile and cozy appearance, pastel and warm tones, handcrafted look with subtle imperfections.'
  }
] as const;

export const DEFAULT_SELECTED_ID = '1' as const;
